var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "12.918", viewBox: "0 0 15 12.918" }, props),
    React.createElement(
      "g",
      null,
      React.createElement("path", { d: "M6.473 0h2.053v12.918H6.473z" }),
      React.createElement("path", { d: "M2.651 10.864h9.697v2.053H2.651z" }),
      React.createElement("rect", { width: "15", height: "9.017", rx: ".5" })
    )
  );
});